import { Form, Spin } from "antd";
import PropTypes from "prop-types";
import { useEffect } from "react";

import { ProgressBarStylesProps } from "@/components/Elements/ProgressBar";
import { useUpdate } from "@/hooks/queries";
import { useAppNotification } from "@/modules/app-notification";

import ProgressEditField from "./ProgressEditField";
import "./ProgressEditForm.style.less";

const { useForm } = Form;

const ProgressEditForm = ({ type, model, ...progressBarProps }) => {
  const [form] = useForm();
  const { notify } = useAppNotification();

  const onError = () => {
    notify.error();
    form.resetFields();
  };

  const { mutate, isPending: isLoading } = useUpdate(`${type}s`, model?.id, {
    mutationOptions: { onError },
  });

  // TODO IMP-1217 fix require-await
  // eslint-disable-next-line require-await
  const onValuesChange = async ({ progress }) => {
    if (progress !== model?.progress) mutate({ progress });
  };

  useEffect(() => {
    form.resetFields();
  }, [model]);

  return (
    <Spin spinning={isLoading}>
      <Form
        form={form}
        name="progress-edit"
        className="progress-edit-form"
        initialValues={{ progress: model?.progress ?? 0 }}
        onValuesChange={onValuesChange}
      >
        <ProgressEditField {...progressBarProps} />
      </Form>
    </Spin>
  );
};

ProgressEditForm.propTypes = {
  type: PropTypes.string.isRequired,
  model: PropTypes.shape({
    id: PropTypes.number.isRequired,
    progress: PropTypes.number,
  }).isRequired,
  ...ProgressBarStylesProps,
};

export default ProgressEditForm;
